// @ts-nocheck
export default (date: Date) => {
    const tempDate = new Date(date);

    if (tempDate.getMinutes() === 0) {
        return true;
    }
};
